// Backstage settings. This file must stay tiny and import nothing (no Amplify,
// no React): the customer bundle imports isBackstagePath from here at boot.

export const BACKSTAGE_PATH: string = import.meta.env.VITE_BACKSTAGE_PATH || 'backstage';
export const BACKSTAGE_BASE = `/${BACKSTAGE_PATH}`;

export function isBackstagePath(pathname: string): boolean {
  return pathname === BACKSTAGE_BASE || pathname.startsWith(`${BACKSTAGE_BASE}/`);
}

const region = import.meta.env.VITE_AWS_REGION || '';
const userPoolId = import.meta.env.VITE_STAFF_USER_POOL_ID || '';
const clientId = import.meta.env.VITE_STAFF_CLIENT_ID || '';
const apiUrl = import.meta.env.VITE_BACKSTAGE_API_URL || '';

export const staffConfig = {
  region,
  userPoolId,
  clientId,
  apiUrl,
  environment: import.meta.env.VITE_BACKSTAGE_ENV || '',
  configured: Boolean(userPoolId && clientId && apiUrl),
};
